import React from 'react';
import FormItem from '../../common/form/FormItem';
import FormPanel from '../../common/form/FormPanel';
import FormWidget from '../../common/form/FormWidget';
import { FormContainer } from '../../common/form/FormContainer';
import { Icons } from '../../common/icons/Icons';
import { Divider, Typography } from '@mui/material';
import { useStyling } from '../../common/Theme';

const BUTTON_LABEL_TO_ICON = {
    Abc: Icons.Abc,
    Attach: Icons.Attachments,
    Delete: Icons.Delete
};

export default () => {
    const { theme } = useStyling();

    const labels = ['Abc', 'Attach', 'Delete'];

    return (
        <FormPanel>
            <Typography fontWeight={theme.typography.fontWeightBold}>Multiple icons</Typography>
            <FormContainer>
                <FormItem>
                    <FormWidget
                        component={'Buttons'}
                        name={'Lab Multiple Icons Buttons'}
                        labels={labels}
                        setIcon={(index: number) => BUTTON_LABEL_TO_ICON[labels[index]]}
                    />
                </FormItem>
            </FormContainer>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Typography fontWeight={theme.typography.fontWeightBold}>Repetitive icon</Typography>
            <FormContainer>
                <FormItem>
                    <FormWidget
                        component={'Buttons'}
                        name={'Lab Repetitive Icon Buttons'}
                        labels={['Production Note', 'Resource Note', 'Leads Note']}
                        setIcon={() => Icons.NotesOutlined}
                    />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
